import React, { FC } from 'react';
import { Row, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { currencyFormatter } from '@cloudcar-app/cloudcar-components';
import { ProcedureInfo } from 'utils/proceduresInfo';
import styles from './OperationalCostsTable.module.scss';

interface OperationalCostsTableProps {
  loading: boolean;
  data: ProcedureInfo[];
}

const OperationalCostsTable: FC<OperationalCostsTableProps> = (
  props: OperationalCostsTableProps,
) => {
  const { loading, data } = props;

  const columns: ColumnsType<ProcedureInfo> = [
    {
      title: 'Gasto',
      dataIndex: 'name',
      sorter: (a: ProcedureInfo, b: ProcedureInfo) =>
        a.name.toString().localeCompare(b.name.toString()),
    },
    {
      title: 'Valor',
      dataIndex: 'price',
      sorter: (a: ProcedureInfo, b: ProcedureInfo) => a.price - b.price,
      render: (price: number) =>
        price ? currencyFormatter().format(price) : '-',
      align: 'right',
    },
  ];

  return (
    <Row justify="center" className={styles.TableContainer}>
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.key}
        pagination={false}
      />
    </Row>
  );
};

export default OperationalCostsTable;
